module.exports = __webpack_public_path__ + "static/img/bg-pt.abfdc71d.webp";